<ng-container *ngIf="data">
  <mb-section-headline
    *ngIf="data.type === teaserSectionType.HEADLINE; else switchTpl"
    [headline]="data.headline"
    [anchor]="data.anchor"
  ></mb-section-headline>

  <ng-template #switchTpl>
    <ng-container [ngSwitch]="data.type">
      <mb-section-headline
        *ngIf="(data.headline || data.anchor) && !data.customHeadline"
        [headline]="data.headline"
        [anchor]="data.anchor"
        [class.show]="show"
        [ngClass]="sectionHeadlineClasses"
      >
      </mb-section-headline>

      <mb-stage-section
        *ngSwitchCase="teaserSectionType.STAGE"
        [isMainStage]="index === 0"
        [items]="data.items"
      ></mb-stage-section>

      <mb-announcement-banner *ngSwitchCase="teaserSectionType.ANNOUNCEMENT" [data]="data"></mb-announcement-banner>

      <mb-hero-section
        *ngSwitchCase="teaserSectionType.HERO"
        [data]="data"
        (openMedia)="openMedia.emit($event)"
      ></mb-hero-section>

      <mb-equal3-section
        (openMedia)="openMedia.emit($event)"
        *ngSwitchCase="teaserSectionType.EQUAL_3"
        [data]="data"
      ></mb-equal3-section>

      <mb-equal4-section
        *ngSwitchCase="teaserSectionType.EQUAL_4"
        [data]="data"
        (openMedia)="openMedia.emit($event)"
      ></mb-equal4-section>

      <mb-press-kit-section *ngSwitchCase="teaserSectionType.PRESSKIT" [pressKitSection]="data"></mb-press-kit-section>

      <mb-square-section
        [inverted]="data.inverted"
        *ngSwitchCase="teaserSectionType.SQUARE"
        [data]="data"
        (openMedia)="openMedia.emit($event)"
      ></mb-square-section>

      <mb-info-section
        *ngSwitchCase="teaserSectionType.INFO"
        [anchor]="data.anchor"
        [infoType]="data.infoType"
        [headline]="data.title"
        [text]="data.text"
        [buttonTargetType]="data.buttonTargetType"
        [buttonLabel]="data.buttonLabel"
        [buttonLink]="data.buttonLink"
        [qaForm]="data.qaForm"
      ></mb-info-section>

      <mb-staggered-section
        *ngSwitchCase="teaserSectionType.STAGGERED"
        [data]="data"
        (openMedia)="openMedia.emit($event)"
      ></mb-staggered-section>

      <mb-contact-section *ngSwitchCase="teaserSectionType.CONTACT" [data]="data"></mb-contact-section>

      <mb-carousel-section
        *ngSwitchCase="teaserSectionType.CAROUSEL"
        [items]="data.teasers"
        [ratio]="data.ratio"
        (openMedia)="openMedia.emit($event)"
      ></mb-carousel-section>

      <mb-event-ribbon-section *ngSwitchCase="teaserSectionType.EVENT_RIBBON"></mb-event-ribbon-section>

      <mb-test-car-section
        *ngSwitchCase="teaserSectionType.TEST_CAR"
        [sectionId]="data.id"
        [items]="data.teasers"
        [filters]="data.filters"
        [headline]="data.headline"
        [anchor]="data.anchor"
      ></mb-test-car-section>

      <mb-agenda-section *ngSwitchCase="teaserSectionType.AGENDA" [agenda]="data"></mb-agenda-section>

      <mb-test-route-section *ngSwitchCase="teaserSectionType.TEST_ROUTE" [data]="data"></mb-test-route-section>

      <mb-event-registration-section
        *ngSwitchCase="teaserSectionType.EVENT_REGISTRATION"
        [eventId]="data.eventId"
        (showSection)="show = $event"
      ></mb-event-registration-section>

      <mb-event-presenters-section
        *ngSwitchCase="teaserSectionType.EVENT_CONTACTS"
        [eventId]="data.eventId"
        (showSection)="show = $event"
        [sectionType]="teaserSectionType.EVENT_CONTACTS"
      ></mb-event-presenters-section>

      <mb-event-presenters-section
        *ngSwitchCase="teaserSectionType.EVENT_EXPERTS"
        [eventId]="data.eventId"
        (showSection)="show = $event"
        [sectionType]="teaserSectionType.EVENT_EXPERTS"
      ></mb-event-presenters-section>

      <mb-highlight-section
        *ngSwitchCase="teaserSectionType.HIGHLIGHT"
        [highlightSection]="data"
      ></mb-highlight-section>

      <ng-container *ngSwitchCase="teaserSectionType.DYNAMIC">
        <mb-dynamic-section
          *ngIf="data.hasContent"
          [topicId]="data.topicId"
          [title]="data.title"
          [entities]="data.entities"
          [filterGroups]="data.filterGroups"
          [assetsCount]="data.assetsCount"
          [showSingleTabNav]="data.showSingleTabNav"
          [showShowAllButton]="data.showShowAllButton"
        ></mb-dynamic-section>
      </ng-container>
    </ng-container>
  </ng-template>
</ng-container>
